module.exports = __webpack_public_path__ + "img/priscilla-du-preez-XkKCui44iM0-unsplash.ead67daa.jpg";